
<div *ngIf="!loaded" class="d-flex justify-content-center" style="margin-top: 85px;">
  <div class="spinner-border text-success" style="width: 4rem; height: 4rem;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div class="container-fluid" *ngIf="loaded">

    <div class="pageheader d-flex align-items-center justify-content-between mb-3">
        <h4 class="d-flex align-items-center mb-1">
            <fa-icon class="me-2" [icon]="faBuilding"></fa-icon> {{ companyGroupDetails?.name }} <span *ngIf="!companyGroupDetails?.active" class="ms-2 badge bg-danger"> Inactive </span>
        </h4>
        <button class="btn btn-success" (click)="editCompanyGroup()" *ngIf="companyGroupId > 1">
            <fa-icon [icon]="faPencil"></fa-icon>
        </button>
    </div>

     <!-- Details Card -->
  <app-card class="mb-3" *ngIf="companyGroupId > 1">
    <div class="row g-3">

      <div class="col-sm-6 col-lg-3">
        <div class="text-muted small fw-semibold mb-1">Admin Email</div>
        <div>{{ companyGroupDetails?.adminEmailAddress || '-' }}</div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="text-muted small fw-semibold mb-1">Manager Email</div>
        <div>{{ companyGroupDetails?.managerEmailAddress || '-' }}</div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="text-muted small fw-semibold mb-1">Equity Release Fee</div>
        <div>{{ companyGroupDetails?.equityReleaseFee != null ? ('£' + companyGroupDetails.equityReleaseFee) : '-' }}</div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="text-muted small fw-semibold mb-1">Restrict FA Access &amp; Emails</div>
        <div>
          <span class="badge" [ngClass]="companyGroupDetails?.noAccessOrUpdatesForFAs ? 'bg-danger' : 'bg-success'">
            {{ companyGroupDetails?.noAccessOrUpdatesForFAs ? 'Yes' : 'No' }}
          </span>
        </div>
      </div>

      <div class="col-12" *ngIf="companyGroupDetails?.information">
        <div class="text-muted small fw-semibold mb-1">Additional Information</div>
        <div>{{ companyGroupDetails.information }}</div>
      </div>

    </div>
  </app-card>

   <!-- Tabs -->
  <ul class="nav nav-underline nav-fill">
    <li class="nav-item">
      <a class="nav-link"
        [class.active]="activeTab === 'users'"
        (click)="activeTab = 'users'">
        Users
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link"
        [class.active]="activeTab === 'cases'"
        (click)="activeTab = 'cases'">
        Cases
      </a>
    </li>
  </ul>

  <div>
    <app-card>
      <!-- Users content here -->
      <div *ngIf="activeTab === 'users'">
        <app-company-group-users [companyGroupId]="companyGroupId"></app-company-group-users>
      </div>

      <!-- Cases content here -->
      <div *ngIf="activeTab === 'cases'">
        <app-company-group-cases [companyGroupId]="companyGroupId"></app-company-group-cases>
      </div>
    </app-card>
  </div>

</div>
